import Chip, { ChipProps } from '@mui/material/Chip'
import { useTimeSinceNow } from '../../../Utilities/useTimeSinceNow'
import { DeclinedIcon, MailIcon } from '../../Icons/Icons'

interface SentAtChipProps extends ChipProps {
  sentAt: string
}

interface DeclinedAtChipProps extends ChipProps {
  declinedAt: string
}

export const SentAtChip = ({
  sentAt,
  ...props
}: SentAtChipProps): JSX.Element => {
  return (
    <Chip
      variant='subtle'
      color='info'
      style={{ flexShrink: 0 }}
      icon={<MailIcon titleAccess='Received' />}
      label={useTimeSinceNow(sentAt).timeSince}
      {...props}
    />
  )
}

export const DeclinedAtChip = ({
  declinedAt,
  ...props
}: DeclinedAtChipProps): JSX.Element => {
  return (
    <Chip
      variant='subtle'
      color='info'
      style={{ flexShrink: 0 }}
      icon={<DeclinedIcon titleAccess='Declined' />}
      label={useTimeSinceNow(declinedAt).timeSince}
      size='small'
      {...props}
    />
  )
}
